import PropTypes from 'prop-types';
import styles from './FloorplanDataCard.module.css';

export default function FloorplanDataCard({ 
    planName = '',
    sqft = '',
    beds = '',
    baths = '',
    garage = '',
    stories = '',
    url = '',
    onMoreInfo
}) {
    const handleMoreInfo = () => {
        if (url) {
            window.open(url, '_blank', 'noopener,noreferrer');
        } else if (onMoreInfo) {
            onMoreInfo();
        }
    };
    return (
        <div className={styles.card}>
            {/* Plan Name */}
            <h2 className={styles.planName}>{planName}</h2>
            
            {/* Coral Red Divider */}
            <div className={styles.divider}></div>
            
            {/* Square Footage */}
            <div className={styles.sqftSection}>
                <p className={styles.label}>Sq. Ft.</p>
                <p className={styles.value}>{sqft}</p>
            </div>
            
            {/* Horizontal Divider */}
            <div className={styles.horizontalDivider}></div>
            
            {/* Beds and Baths Row */}
            <div className={styles.statsRow}>
                <div className={styles.statItem}>
                    <p className={styles.statValue}>{beds}</p>
                    <p className={styles.statLabel}>Beds</p>
                </div>
                <div className={styles.verticalDivider}></div>
                <div className={styles.statItem}>
                    <p className={styles.statValue}>{baths}</p>
                    <p className={styles.statLabel}>Baths</p>
                </div>
            </div>
            
            {/* Horizontal Divider */}
            <div className={styles.horizontalDivider}></div>
            
            {/* Garage and Stories Row */}
            <div className={styles.statsRow}>
                <div className={styles.statItem}>
                    <p className={styles.statValue}>{garage}</p>
                    <p className={styles.statLabel}>Garage</p>
                </div>
                <div className={styles.verticalDivider}></div>
                <div className={styles.statItem}>
                    <p className={styles.statValue}>{stories}</p>
                    <p className={styles.statLabel}>Stories</p>
                </div>
            </div>
            
            {/* Horizontal Divider */}
            <div className={styles.horizontalDivider}></div>
            
            {/* More Info Button */}
            <button 
                className={styles.moreInfoButton}
                onClick={handleMoreInfo}
            >
                MORE INFO
            </button>
        </div>
    );
}

FloorplanDataCard.propTypes = {
    planName: PropTypes.string,
    sqft: PropTypes.string,
    beds: PropTypes.string,
    baths: PropTypes.string,
    garage: PropTypes.string,
    stories: PropTypes.string,
    url: PropTypes.string,
    onMoreInfo: PropTypes.func
};
